// components/PasteExcelIcon.jsx
import React, { useState } from 'react';
import {
  IconButton,
  Tooltip,
  Badge
} from '@mui/material';
import {
  ContentPaste as PasteIcon
} from '@mui/icons-material';
import ExcelPasteModal from './ExcelPasteModal';

function PasteExcelIcon({ 
  onDataImported, 
  tooltipTitle = "Paste data dari Excel",
  showBadge = false,
  badgeContent = 0
}) {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleDataImported = (data, headers, summary) => {
    if (onDataImported) {
      onDataImported(data, headers, summary);
    }
    handleCloseModal();
  };

  return (
    <>
      <Tooltip title={tooltipTitle}>
        <IconButton 
          color="inherit" 
          onClick={handleOpenModal}
          sx={{ ml: 1 }}
        >
          {showBadge && badgeContent > 0 ? (
            <Badge badgeContent={badgeContent} color="error">
              <PasteIcon />
            </Badge>
          ) : (
            <PasteIcon />
          )}
        </IconButton>
      </Tooltip>

      <ExcelPasteModal
        open={openModal}
        onClose={handleCloseModal}
        onDataImported={handleDataImported}
      />
    </>
  );
}

export default PasteExcelIcon;